const translations = {
  'fr': {
    'For Make' : 'Pour Marque',
    'Model' : 'Modèle',
    'Length' : 'Longueur',
    'Pitch' : 'Pas',
    'Gauge' : 'Épaisseur',
    'Grinder Accessories' : 'Accessoires pour meuleuse',
    'Bolt Size' : 'Taille de boulon',
    'Stump Pocket Type' : 'Type de logement de souche',
    'Bent' : 'Courbé',
    'Straight' : 'Droit',
    'Size' : 'Taille',
    'Standard' : 'Standard',
    'XL' : 'XL (Très Grand)',
    '10 - Large' : '10 - Grand',
    '8 - Small' : '8 - Petit',
    '9 - Medium' : '9 - Moyen',
    'Pay in 3 interest-free payments with' : 'Payez en 3 fois sans frais avec',
    'Learn more' : 'En savoir plus',
    'Product category' : 'Catégorie de produit',
    'Chainsaw Accessories' : 'Accessoires pour tronçonneuses',
    'Chainsaw Bars' : 'Guides-chaînes',
    'Chainsaw Chains' : 'Chaînes de tronçonneuse',
    'Chippers' : 'Broyeurs',
    'Safety Gloves' : 'Gants de sécurité',
    'Pruning Saws' : 'Scies d’élagage',
    'Grinder Accessories' : 'Accessoires pour meuleuses',
    'Coats & Jackets' : 'Manteaux & vestes',
    'Shirts & Tops' : 'Chemises & hauts',
    'Hats' : 'Chapeaux',
    'Pitch' : 'Pas',
    '3/8" (Low Profile)' : '3/8" (Profil bas)',
    '3/8th Low Profile' : '3/8" profil bas',
    'Transport' : 'Transport',
    'Manual' : 'Manuel',
    'Towable' : 'Remorquable',
    'Pickup unavailable on this item' : 'Retrait en magasin indisponible pour cet article',
    'Item out of stock' : 'Article en rupture de stock',
    'One of the Most Powerful Electric Chippers on the Market' : 'L’un des broyeurs électriques les plus puissants du marché',
    'Designed to outperform...' : 'Conçu pour surpasser les broyeurs classiques...',
    'Power Through Timber Up to 80mm Thick' : 'Broyage de bois jusqu’à 80mm d’épaisseur',
    'With a 2–4m³/hour throughput...' : 'Avec un débit de 2–4m³/h...',
    'Serious Chipping Performance, Anywhere You Need It' : 'Puissance de broyage sérieuse, où que vous soyez',
    'Lightweight at 95kg and just 540mm wide...' : 'Léger (95 kg) et compact (540 mm de large) – passe partout',
    '1.2 Metres (4ft)' : '1,2 mètres (4 pieds)',
    '1.8 Metres (6ft)' : '1,8 mètres (6 pieds)',
    '2.4 Metres (8ft)' : '2,4 mètres (8 pieds)',
    '3 Metres (10ft)' : '3 mètres (10 pieds)',
    '3.6 Metres (12ft)' : '3,6 mètres (12 pieds)',
    '4.2 Metres (14ft)' : '4,2 mètres (14 pieds)',
    '4.8 Metres (16ft)' : '4,8 mètres (16 pieds)',
    'L - Large' : 'L – Grand',
    'M - Medium' : 'M – Moyen',
    'XL - Extra Large' : 'XL – Très grand',
    'Buy multiple sets for big savings' : 'Achetez en lot pour faire des économies',
    'Buy 2 sets and save 5%' : 'Achetez 2 lots – économisez 5 %',
    'Save 5%!' : 'Économisez 5 %!',
    'Buy 3 sets and save 10%' : 'Achetez 3 lots – économisez 10 %',
    'Save 10%' : 'Économisez 10 %!',
    'Save 10%' : 'Économisez 10 %!',
    'I acknowledge that additional duties and taxes will need to be paid if shipping outside the UK' : 'Je reconnais que des droits de douane et taxes supplémentaires devront être réglés pour les livraisons hors du Royaume-Uni.',
    'If shipping outside of the UK, please provide your EORI or PID number here:' : 'Si vous expédiez en dehors du Royaume-Uni, merci d’indiquer ici votre numéro EORI ou PID :',
    '*Please note: Non-UK order will not be dispatched until an EORI or PID number has provided' : '*À noter : toute commande en dehors du Royaume-Uni ne sera expédiée qu’une fois le numéro EORI ou PID fourni',
    'EORI or PID' : 'Numéro EORI ou PID',
    'You Might Like' : 'Vous pourriez aimer',
    'Precision Engineered OEM Compatibility' : 'Conception de précision – compatible OEM à 100 %',
    'Exceptional Performance & Durability' : 'Performances et durabilité exceptionnelles',
    'Enhance Productivity & Reduce Downtime' : 'Productivité accrue, moins d’arrêts',
    'Backed by our Knifetime Guarantee' : 'Garantie Knifetime incluse',
    'Hardened steel construction for superior durability and extended service life' : 'Construction en acier trempé pour une durabilité exceptionnelle et une longue durée de vie',
    'Made to OEM dimensions, guaranteeing a secure and reliable fit' : 'Conçu selon les dimensions OEM, garantissant un ajustement sûr et fiable',
    'Precision-engineered to ensure optimal chipping performance' : 'Conçu avec précision pour assurer des performances de broyage optimales',
    'Designed to minimize downtime with easy replacement' : 'Conçu pour minimiser les temps d\'arrêt grâce à un remplacement facile',
    'Manufactured to OEM specifications for a precise fit and consistent performance' : 'Fabriqué selon les spécifications OEM pour un ajustement précis et des performances constantes',
    'Can be re-sharpened multiple times, maximizing blade lifespan' : 'Peut être réaffûtée plusieurs fois pour prolonger au maximum la durée de vie de la lame',
    'Torque to 310nm ensures secure and precise installation' : 'Couple de serrage à 310 Nm pour une installation sûre et précise',
    'Visible 60mm wear line for easy wear monitoring' : 'Ligne d’usure visible de 60 mm pour surveiller facilement l’état de la pièce',
    'incl. VAT' : 'TTC (toutes taxes comprises)',
    'exc. VAT' : 'HT (hors taxes)',
    'Total' : 'Total',
    'Chainsaw Chains' : 'Chaînes de tronçonneuse',
    'Semi-Chisel' : 'Semi-burin',
    'Full Chisel' : 'Plein burin',
    'Chainsaw Bars' : 'Barres de tronçonneuse',
    'Chipper Anvils' : 'Enclumes de broyeur',
    'Chipper Blades' : 'Lames de broyeur',
    'Grinder Teeth' : 'Dents de broyeur',
    'Pole Pruner Chains' : 'Chaînes pour perches élagueuses',
    'Grinder Pockets' : 'Support de dent de rogneuse',
    'Wood Chipper' : 'Broyeur de bois',
    'Manual' : 'Manuel',
    'Brushless' : 'Sans balais',
    'Yes' : 'Oui',
    '1 Year' : '1 an',
    'Customer Reviews' : 'Avis clients',
    'Be the first to write a review' : 'Soyez le premier à laisser un avis',
    'Write a review' : 'Laisser un avis',
    'Wood Chipper Accessories' : 'Accessoires pour broyeur',
    'Standard Charge to Customer (inc VAT)' : 'Frais standards au client (TVA incluse)',
    'Express Upgrade Charge to Customer (inc VAT)' : 'Supplément express au client (TVA incluse)',
    'Express International' : 'Livraison express internationale',
    'DUTY-FREE SHIPPING ON ALL INTERNATIONAL ORDERS!' : 'LIVRAISON SANS DROITS DE DOUANE POUR TOUTES LES COMMANDES INTERNATIONALES !',
  },
  'de': {
    'For Make' : 'Für Marke',
    'Model' : 'Modell',
    'Length' : 'Länge',
    'Pitch' : 'Teilung',
    'Gauge' : 'Stärke',
    'Grinder Accessories' : 'Schleifzubehör',
    'Bolt Size' : 'Schraubengröße',
    'Stump Pocket Type' : 'Frässtumpf-Aufnahmeart',
    'Bent' : 'Gebogen',
    'Straight' : 'Gerade',
    'Size' : 'Größe',
    'Standard' : 'Standard',
    'XL' : 'XL (Extra Groß)',
    '10 - Large' : '10 - Groß',
    '8 - Small' : '8 - Klein',
    '9 - Medium' : '9 - Mittel',
    'Pay in 3 interest-free payments with' : 'In 3 zinsfreien Raten zahlen mit',
    'Learn more' : 'Mehr erfahren',
    'Product category' : 'Produktkategorie',
    'Chainsaw Accessories' : 'Kettensägen-Zubehör',
    'Chainsaw Bars' : 'Schienen für Kettensägen',
    'Chainsaw Chains' : 'Kettensägenketten',
    'Chippers' : 'Häcksler',
    'Safety Gloves' : 'Schutzhandschuhe',
    'Pruning Saws' : 'Astsägen',
    'Grinder Accessories' : 'Schleifzubehör',
    'Coats & Jackets' : 'Mäntel & Jacken',
    'Shirts & Tops' : 'Hemden & Oberteile',
    'Hats' : 'Hüte',
    'Pitch' : 'Teilung',
    '3/8" (Low Profile)' : '3/8" (Low Profile)',
    '3/8th Low Profile' : '3/8" Low Profile',
    'Transport' : 'Transport',
    'Manual' : 'Manuell',
    'Towable' : 'Anhängerfähig',
    'Pickup unavailable on this item' : 'Abholung für diesen Artikel nicht verfügbar',
    'Item out of stock' : 'Artikel nicht auf Lager',
    'One of the Most Powerful Electric Chippers on the Market' : 'Einer der stärksten Elektrohacker auf dem Markt',
    'Designed to outperform...' : 'Entwickelt, um herkömmliche Hacker zu übertreffen...',
    'Power Through Timber Up to 80mm Thick' : 'Zerkleinert Äste bis zu 80mm dick',
    'With a 2–4m³/hour throughput...' : 'Mit 2–4m³/h Durchsatz...',
    'Serious Chipping Performance, Anywhere You Need It' : 'Starke Häckselleistung – überall einsetzbar',
    'Lightweight at 95kg and just 540mm wide...' : 'Nur 95 kg leicht & 540 mm breit – passt durch jede Ecke',
    '1.2 Metres (4ft)' : '1,2 Meter (4 Fuß)',
    '1.8 Metres (6ft)' : '1,8 Meter (6 Fuß)',
    '2.4 Metres (8ft)' : '2,4 Meter (8 Fuß)',
    '3 Metres (10ft)' : '3 Meter (10 Fuß)',
    '3.6 Metres (12ft)' : '3,6 Meter (12 Fuß)',
    '4.2 Metres (14ft)' : '4,2 Meter (14 Fuß)',
    '4.8 Metres (16ft)' : '4,8 Meter (16 Fuß)',
    'L - Large' : 'L – Groß',
    'M - Medium' : 'M – Mittel',
    'XL - Extra Large' : 'XL – Extra Groß',
    'Buy multiple sets for big savings' : 'Mehrere Sets kaufen und kräftig sparen',
    'Buy 2 sets and save 5%' : '2 Sets kaufen – 5 % sparen',
    'Save 5%!' : '5 % sparen!',
    'Buy 3 sets and save 10%' : '3 Sets kaufen – 10 % sparen',
    'Save 10%' : '10 % sparen!',
    'Save 10%' : '10 % sparen!',
    'I acknowledge that additional duties and taxes will need to be paid if shipping outside the UK' : 'Ich bestätige, dass bei Lieferungen außerhalb des Vereinigten Königreichs zusätzliche Zölle und Steuern anfallen.',
    'If shipping outside of the UK, please provide your EORI or PID number here:' : 'Bei Versand außerhalb des Vereinigten Königreichs geben Sie bitte hier Ihre EORI- oder PID-Nummer an:',
    '*Please note: Non-UK order will not be dispatched until an EORI or PID number has provided' : '*Bitte beachten: Bestellungen außerhalb des Vereinigten Königreichs werden erst nach Angabe einer EORI- oder PID-Nummer versendet',
    'EORI or PID' : 'EORI- oder PID-Nummer',
    'You Might Like' : 'Das könnte dir gefallen',
    'Precision Engineered OEM Compatibility' : 'Passgenau entwickelt – 100 % OEM-kompatibel',
    'Exceptional Performance & Durability' : 'Top-Leistung & extra lange Haltbarkeit',
    'Enhance Productivity & Reduce Downtime' : 'Mehr Effizienz, weniger Stillstand',
    'Backed by our Knifetime Guarantee' : 'Abgesichert durch unsere Knifetime-Garantie',
    'Hardened steel construction for superior durability and extended service life' : 'Gehärtete Stahlkonstruktion für überragende Haltbarkeit und lange Lebensdauer',
    'Made to OEM dimensions, guaranteeing a secure and reliable fit' : 'Gefertigt nach OEM-Maßen für eine sichere und zuverlässige Passform',
    'Precision-engineered to ensure optimal chipping performance' : 'Präzisionsgefertigt für optimale Häckselleistung',
    'Designed to minimize downtime with easy replacement' : 'Entwickelt für minimale Ausfallzeiten durch einfachen Austausch',
    'Manufactured to OEM specifications for a precise fit and consistent performance' : 'Nach OEM-Spezifikationen gefertigt – für perfekten Sitz und gleichbleibende Leistung',
    'Can be re-sharpened multiple times, maximizing blade lifespan' : 'Mehrfach nachschärfbar – für eine deutlich längere Lebensdauer der Klinge',
    'Torque to 310nm ensures secure and precise installation' : 'Mit 310 Nm festziehen – für sicheren und passgenauen Einbau',
    'Visible 60mm wear line for easy wear monitoring' : 'Sichtbare 60 mm Verschleißlinie – zur einfachen Kontrolle des Abnutzungsgrads',
    'incl. VAT' : 'inkl. MwSt',
    'exc. VAT' : 'exkl. MwSt',
    'Total' : 'Gesamt',
    'Chainsaw Chains' : 'Sägeketten',
    'Semi-Chisel' : 'Halbmeißel',
    'Full Chisel' : 'Vollmeißel',
    'Chainsaw Bars' : 'Führungsschienen für Kettensägen',
    'Chipper Anvils' : 'Häcksler-Ambosse',
    'Chipper Blades' : 'Häcksler-Messer',
    'Grinder Teeth' : 'Fräszähne',
    'Pole Pruner Chains' : 'Hochentaster-Ketten',
    'Grinder Pockets' : 'Fräszahn-Halter',
    'Wood Chipper' : 'Holzhäcksler',
    'Manual' : 'Manuell',
    'Brushless' : 'Bürstenlos',
    'Yes' : 'Ja',
    '1 Year' : '1 Jahr',
    'Customer Reviews' : 'Kundenbewertungen',
    'Be the first to write a review' : 'Sei der Erste, der eine Bewertung schreibt',
    'Write a review' : 'Bewertung schreiben',
    'Wood Chipper Accessories' : 'Häcksler-Zubehör',
    'Standard Charge to Customer (inc VAT)' : 'Standardgebühr für Kunden (inkl. MwSt.)',
    'Express Upgrade Charge to Customer (inc VAT)' : 'Expresszuschlag für Kunden (inkl. MwSt.)',
    'Express International' : 'Internationaler Expressversand',
    'DUTY-FREE SHIPPING ON ALL INTERNATIONAL ORDERS!' : 'ZOLLFREIER VERSAND BEI ALLEN INTERNATIONALEN BESTELLUNGEN!',
  }
};



function translateTextContent(node) {
  const locale_code = document.querySelector("input[name=locale_code]").value;
  const currentTranslations = translations[locale_code];

  if (node.nodeType === Node.TEXT_NODE) {
    let text = node.nodeValue.trim();
    
    if (currentTranslations[text]) {
      node.nodeValue = currentTranslations[text];
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (let child of node.childNodes) {
      translateTextContent(child);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  translateTextContent(document.body);

  // Observe for dynamic content (e.g., from Boost, theme scripts)
  const observer = new MutationObserver(() => {
    translateTextContent(document.body);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
